import React,{useCallback, useRef} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import airportData from "../data.json";
import CircularProgress from "@material-ui/core/CircularProgress";
import SegmentDetail from "./SegmentDetail";
import {getDateDifference} from '../../../helpers/date.helper'
const useStyles = makeStyles((theme) => ({
    paper: {
      height: 140,
      width: 100,
    },
    control: {
      padding: "4%",
      marginBottom: "2%",
    },
    main: {
      paddingTop: "10%",
      // backgroundColor: "rgb(246, 249, 252)",
      minHeight: "100vh",
      [theme.breakpoints.down("sm")]: {
        paddingTop: "32%",
      },
    },
  }));
function SelectedFlight(props)
{
    const classes = useStyles();
    const {flight,loading}=props;
    return(<div className="flight-details">     
        <Grid item xs="12" sm="12" style={{ textAlign: "left" }}>
          {flight &&
            flight.slices.map((airport) => {
              return (
                <>                 
                  <Grid container >
                    {airport.segments.map((segment, index) => {
                      return (
                        <SegmentDetail
                          segment={segment}
                          index={index}
                          segments={airport.segments}
                        />
                      );
                    })}
                  </Grid>
                </>
              );
            })}
        </Grid>
         {loading && <CircularProgress />}
 
  </div>)
}
export default React.memo(SelectedFlight)

SelectedFlight.defaultProps = {
  showHeading:true
  
}
